import { StringTimeFormat } from "./StringTimeFormat";

export const DateFormatWithTime = (inputDate:any) => {
    if(inputDate) {
    const dateObject = new Date(inputDate);
    const day = String(dateObject.getUTCDate()).padStart(2, '0');
    const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const year = dateObject.getUTCFullYear();
    const hours = String(dateObject.getHours())
    const minute = String(dateObject.getMinutes())
    const time = StringTimeFormat(`${hours}:${minute}`)
    const formattedDate = `${month}/${day}/${ year} ${time}`;
    return formattedDate;
    }
    else {
        return null
    }
};
